
import { AllvalueAdditionFiveResponse, valueAdditionFiveResponse, ValueAdditionIdRequest, valueAdditionIdResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ValueAdditionFiveDTO } from './dto/value-addition-five.dto';
import { ValueAdditionFiveRequest } from './dto/value-addition-five.request';
import { ValueAddition5TypesService } from './value-addition5-types.service';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';

@ApiTags('value-addition5-types')
@Controller('value-addition5-types')

export class ValueAddition5TypesController {
    constructor(
        private valAddFiveTypeService: ValueAddition5TypesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

       /**
     * creates or updates a value adaition2 type
     * @param ValueAdditionType ValueAdditionType DTO
     * @returns ValueAdditionTypeResponse
     */
    @Post('/createValAddFiveType')
    async createValAddFiveType(@Body() valAddDto:ValueAdditionFiveDTO,isUpdate:boolean=false,@Req() request:Request): Promise<valueAdditionFiveResponse> {
        try {
         return await this.valAddFiveTypeService.createValAddFiveType(valAddDto,false,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(valueAdditionFiveResponse, error);
       }
     }

      /**
     * gets all the Value Addition Types
     * @returns AllValue AdditionTypesResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

    @Post('/getAllValAddTypes')
    async getAllValAddFiveTypes(@Body() req?:UserRequestDto): Promise<AllvalueAdditionFiveResponse> {
        try {
            return await this.valAddFiveTypeService.getAllValAddFiveTypes(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllvalueAdditionFiveResponse, error);
        }
    }
    @Post('/getAllActiveValAddTypes')
  async getAllActiveValAddTypes(@Req() request: Request): Promise<AllvalueAdditionFiveResponse> {
      try {
          return await this.valAddFiveTypeService.getAllActiveValAddFiveTypes();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllvalueAdditionFiveResponse, error)
      }
  }

     /**
     * Activate Or De-Activate Value AdditionFive Type
     * @param getSingleValAdditionTyoe AdditionFiveType 
     * @returns Value AdditionFiveTypeResponse
     */
   @Post('/activateOrDeactivateValAddFiveType')
   async activateOrDeactivateValAddFiveType(@Body() valAddFiveReq: ValueAdditionFiveRequest): Promise<valueAdditionFiveResponse> {
       try {
           return await this.valAddFiveTypeService.activateOrDeactivateValAddFiveType(valAddFiveReq);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(valueAdditionFiveResponse, err);
       }
   }

      /**
     * creates or updates a value adaition2 type
     * @param ValueAdditionType ValueAdditionType DTO
     * @returns ValueAdditionTypeResponse
     */
       @Post('/updateValAddFiveType')
       async updateValAddFiveType(@Body() valAddDto:ValueAdditionFiveDTO,isUpdate:boolean=true,@Req() request:Request): Promise<valueAdditionFiveResponse> {
           try {
            return await this.valAddFiveTypeService.createValAddFiveType(valAddDto,true,request);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(valueAdditionFiveResponse, error);
          }
        }

    /**
     * Function to get valAddDetails
     * @param valueAdditionId  
     * @returns valueAdditionIdResponse
     */
    @Post('/getValAddDetails')
    async getValAddDetails(@Body() valAddOneReq: ValueAdditionIdRequest): Promise<valueAdditionIdResponse> {
        try {
            return await this.valAddFiveTypeService.getValAddDetails(valAddOneReq.valueAdditionId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(valueAdditionIdResponse, error);
        }
    }    
}

